/**
 * ID编码工具 - 将数字ID转换为随机字符串
 */

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

// 生成指定长度的随机字符
function randomChars(len) {
  let result = ''
  for (let i = 0; i < len; i++) {
    result += CHARS[Math.floor(Math.random() * CHARS.length)]
  }
  return result
}

/**
 * 将数字ID编码为随机字符串
 * 格式: 随机8位 + ID的16进制(补齐8位) + 随机8位 = 24位
 * @param {number|string} id 
 * @returns {string}
 */
export function encodeId(id) {
  if (!id) return ''
  const hex = Number(id).toString(16).toUpperCase().padStart(8, '0')
  const prefix = randomChars(8)
  const suffix = randomChars(8)
  return prefix + hex + suffix
}

/**
 * 将编码字符串解码为数字ID
 * @param {string} encoded 
 * @returns {number|null}
 */
export function decodeId(encoded) {
  if (!encoded || encoded.length !== 24) return null
  try {
    // 去掉前8位和后8位，取中间8位
    const hex = encoded.slice(8, 16)
    return parseInt(hex, 16)
  } catch (e) {
    return null
  }
}
